import { isPrincipalTokenWind } from "@bridgesplit/abf-react";
import { LoopRouteType, TokenListMetadata } from "@bridgesplit/abf-sdk";

import { BaseWinder } from "./BaseWinder";
import { LpWinder } from "./LpWinder";
import { LoopWinder } from "./types";

export class LoopWinderFactory {
    static create(
        routeType: LoopRouteType | undefined,
        inputToken: TokenListMetadata | undefined,
        principalTokenMint: string | undefined
    ): LoopWinder {
        if (routeType === undefined || !inputToken || !principalTokenMint) {
            return new BaseWinder(false);
        }
        const isPrincipalWind = isPrincipalTokenWind(principalTokenMint, inputToken?.mint);

        if (routeType === LoopRouteType.LP) {
            return new LpWinder(isPrincipalWind);
        }

        return new BaseWinder(isPrincipalWind);
    }
}
